// The detector-contact polarity control (TOM-136, core ADR-217): one of two
// answers, "reads ON when tripped" or "reads OFF when tripped", never a 0–1
// number box. One component for both editors, so the full form and the inline
// editor cannot offer different answers.

import { CONTACT_STATE_CHOICES } from '../../lib/alarmDefsForm';

export function ContactStateSelect({
  value,
  onChange,
  allowBlank,
  className,
  testId,
  id,
  ariaLabel,
}: {
  /** The draft's value: `''`, `'1'` or `'0'`. */
  value: string;
  onChange: (value: string) => void;
  /**
   * Whether "not answered yet" is offered. Only while the alarm has never had
   * an answer (`contactStateClearable`): clearing a stored one would disarm a
   * life-safety alarm.
   */
  allowBlank: boolean;
  className: string;
  testId: string;
  id?: string;
  ariaLabel?: string;
}) {
  return (
    <select
      {...(id !== undefined ? { id } : {})}
      className={className}
      value={value}
      {...(ariaLabel !== undefined ? { 'aria-label': ariaLabel } : {})}
      data-testid={testId}
      onChange={(e) => onChange(e.target.value)}
    >
      {allowBlank || value === '' ? (
        <option value="">Not answered yet (the alarm waits)</option>
      ) : null}
      {CONTACT_STATE_CHOICES.map((c) => (
        <option key={c.value} value={c.value}>
          {c.label}
        </option>
      ))}
    </select>
  );
}
